import React, { useMemo, useState } from 'react';
import ProjectCard from './ProjectCard';
import ProjectDetailsModal from './ProjectDetailsModal';
import Toast from './Toast';
import mandates from './mandatesData';
import './ExclusiveMandates.css';


const ExclusiveMandates = ({ firebase }) => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [toast, setToast] = useState(null);

  const projects = useMemo(() => mandates, []);

  const handleSuccess = (message) => {
    setToast({ type: 'success', message });
    setTimeout(() => setToast(null), 3500);
  };

  const handleError = (message) => {
    setToast({ type: 'error', message });
    setTimeout(() => setToast(null), 3500);
  };

  return (
    <div className="exclusive-page">
      <div className="exclusive-header">
        <h1>Exclusive Mandates</h1>
        <p>
          Projects with exclusive rights to sell. Explore details and register as a channel partner.
        </p>
      </div>

      <div className="exclusive-grid">
        {projects.map((project) => (
          <ProjectCard
            key={project.id}
            project={project}
            onViewDetails={() => setSelectedProject(project)}
          />
        ))}
      </div>

      {selectedProject ? (
        <ProjectDetailsModal
          project={selectedProject}
          firebase={firebase}
          onClose={() => setSelectedProject(null)}
          onSuccess={handleSuccess}
          onError={handleError}
        />
      ) : null}

      {toast ? <Toast type={toast.type} message={toast.message} /> : null}
    </div>
  );
};

export default ExclusiveMandates;
